var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "700" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline m-0" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s(_vm.form.id ? "edit" : "add"))]),
                  _vm._v(" Programación de\n        vacaciones\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "px-3 py-2" },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "pa-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.calculaDiferenciaDias()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde", $$v)
                                  },
                                  expression: "form.fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.calculaDiferenciaDias()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_hasta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta", $$v)
                                  },
                                  expression: "form.fecha_hasta"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "" } },
                            [
                              _vm.form.fecha_desde && _vm.form.fecha_hasta
                                ? _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Días",
                                      disabled: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.total_dias,
                                      callback: function($$v) {
                                        _vm.total_dias = $$v
                                      },
                                      expression: "total_dias"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-277f92ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277f92ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/dialogs/CrearActualizarVacaciones.vue
// module id = null
// module chunks = 